"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const TimeAttendance_1 = __importDefault(require("../api/TimeAttendance"));
const cancelable_promise_1 = require("cancelable-promise");
class QuickPunch {
    punch(punchType, callback, stateCallback, promise, userContext, translation) {
        stateCallback(true);
        promise.current?.cancel();
        var punchRequest = {
            punchType,
            timezone: new Date().getTimezoneOffset() / -60,
        };
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => TimeAttendance_1.default.sendPunch(token, punchRequest)))
            .then(data => {
            let dateTime = new Date(data.timestamp);
            let operation = punchType;
            if (operation == "PUNCH_IN") {
                callback(data.timestamp);
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", {
                    type: data.hasMissed ? "warning" : "success",
                    message: translation('time:messages.punchInSuccess') + ' ' + dateTime.toLocaleTimeString() + ' ' + data.timeZone + '.' + (data.hasMissed ? '\r\n' + translation('time:messages.missedPunchWarn') : '')
                });
            }
            else {
                callback(null);
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", {
                    type: data.hasMissed ? "warning" : "success",
                    message: translation('time:messages.punchOutSuccess') + ' ' + dateTime.toLocaleTimeString() + ' ' + data.timeZone + '.' + (data.hasMissed ? '\r\n' + translation('time:messages.missedPunchWarn') : '')
                });
            }
        })
            .catch((err) => {
            var error = '';
            if (err?.status == 400) {
                var timeError = JSON.parse(err.body);
                error = timeError.errorMessage;
            }
            else {
                error = translation('time:messages.punchError');
            }
            if (error.includes('geographical limits')) {
                error = translation('time:messages.punchErrorGeo');
            }
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: error });
        }).finally(() => {
            stateCallback(false);
        });
    }
}
const PunchUtil = new QuickPunch();
exports.default = PunchUtil;
